import { ExampleErrorsRoutes } from './ErrorRoutes';
import { ExampleMStorePageRangeRoutes } from './MStorePageRangeRoutes';
import { ExampleMStoreQuickActionsRoutes } from './MStoreQuickActionsRoutes';
import { ExampleMStoreAccordionRoutes } from './MStoreAccordionRoutes';
import { ExampleMStoreMakeChangesLockRoutes } from './MStoreMakeChangesLockRoutes';
import { ExampleMStoreReferenceSelectionModalRoutes } from './MStoreReferenceSelectionModalRoutes';
import { ExampleMStoreDeleteConfirmationRoutes } from './MStoreDeleteConfirmationRoutes';
import { ExampleMStoreOrderableTableRoutes } from './MStoreOrderableTableRoutes';
import { ExampleReferenceToggleModalRoutes } from './ReferenceToggleModelRoutes';
import { ExampleReferencesAccordionRoutes } from './ReferencesAccordionRoutes';
import { ExampleErrorNotificationRoutes } from './ErrorNotificationRoutes';
import { ExampleMStoreSpinnerButtonRoutes } from './MStoreSpinnerButtonRoutes';
import { ExampleDirtyChangesRoutes } from './DirtyChangesRoutes';
import { ExamplesIndexRoutes } from './IndexRoutes';
import { ExampleMStoreRecurrenceRoutes } from './MStoreRecurrenceRoutes';
import { ExampleMStoreTableRoutes } from './MStoreTableRoutes';
import { ExampleBuiltInListDynamicFormModal } from './BuiltInListModalRoutes';
import { SandboxRoutes } from './Sandbox';
import { ExampleMStoreColumnConfigurationRoutes } from './MStoreColumnConfiguration';
import { ExampleDocumentEmailToMeModalRoutes } from './DocumentEmailToMeModal';
import { ExampleDebugRoutes } from './Debug';

export const ExampleRoutes = [
  ...ExamplesIndexRoutes,
  ...ExampleErrorsRoutes,
  ...ExampleMStorePageRangeRoutes,
  ...ExampleMStoreQuickActionsRoutes,
  ...ExampleMStoreAccordionRoutes,
  ...ExampleMStoreMakeChangesLockRoutes,
  ...ExampleReferenceToggleModalRoutes,
  ...ExampleMStoreReferenceSelectionModalRoutes,
  ...ExampleMStoreOrderableTableRoutes,
  ...ExampleMStoreDeleteConfirmationRoutes,
  ...ExampleReferencesAccordionRoutes,
  ...ExampleErrorNotificationRoutes,
  ...ExampleMStoreSpinnerButtonRoutes,
  ...ExampleDirtyChangesRoutes,
  ...ExampleMStoreRecurrenceRoutes,
  ...ExampleMStoreTableRoutes,
  ...ExampleBuiltInListDynamicFormModal,
  ...SandboxRoutes,
  ...ExampleMStoreColumnConfigurationRoutes,
  ...ExampleDocumentEmailToMeModalRoutes,
  ...ExampleDebugRoutes
];
